<template>
  <div>
    <loader :loading="loading"/>
    <div class="l-row" v-if="!loading">
      <form-group :label="$t('category.label')" :columns="6">
        <select v-model="filters.category" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="category in categories" :value="category" :key="category">{{ category }}</option>
        </select>
      </form-group>

      <form-group :label="$t('brand.label')" :columns="6">
        <select v-model="filters.brand" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="brand in brands" :value="brand" :key="brand">{{ brand }}</option>
        </select>
      </form-group>

      <form-group :label="$t('ageGroup.label')" :columns="6">
        <select v-model="filters.ageGroup" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="ageGroup in ageGroups" :value="ageGroup" :key="ageGroup">{{ $t(`${ageGroup}.label`) }}</option>
        </select>
      </form-group>

      <form-group :label="$t('gender.label')" :columns="6">
        <select v-model="filters.gender" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="gender in genders" :value="gender" :key="gender">{{ $t(`gender.${gender}.label`) }}</option>
        </select>
      </form-group>

      <form-group label="Faixa de preço" :columns="6" v-if="priceRange">
        <div class="slider">
          <slider :range="true" :format="formatRangePrice" :min="priceRange.less" :max="priceRange.highest" @change="changeRange"/>
        </div>
      </form-group>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import Loader from '@/components/template/Loader'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      loading: true,
      brands: [],
      categories: [],
      genders: [],
      ageGroups: [],
      priceRange: null,
      filters: {
        category: null,
        brand: null,
        gender: null,
        ageGroup: null,
        price: {
          from: 0,
          to: 0
        }
      }
    }),
    props: {
      source: {
        type: Object,
        required: true
      }
    },
    mounted () {
      Promise.all([
        api.getCategories(this.source.type, this.source.identifier)
          .then(categories => { this.categories = categories })
          .catch(() => { this.categories = [] }),

        api.getBrands(this.source.type, this.source.identifier)
          .then(brands => { this.brands = brands })
          .catch(() => { this.brands = [] }),

        api.getGenders(this.source.type, this.source.identifier)
          .then(genders => {
            this.genders = genders
          })
          .catch(() => { this.genders = [] }),

        api.getAgeGroups(this.source.type, this.source.identifier)
          .then(ageGroups => { this.ageGroups = ageGroups })
          .catch(() => { this.ageGroups = [] }),

        api.getPriceLessAndHighest(this.source.type, this.source.identifier)
          .then(priceRange => { this.priceRange = priceRange })
          .catch(() => {
            this.priceRange = {
              less: 0,
              highest: 1000
            }

            this.filters.price = {
              from: this.priceRange.less,
              to: this.priceRange.highest
            }
          })
      ])
        .then(() => { this.loading = false })
    },
    methods: {
      changeRange (value) {
        this.filters.price.from = value[0]
        this.filters.price.to = value[1]
      },
      formatRangePrice (value) {
        return `R$ ${value},00`
      }
    },
    components: {
      FormGroup,
      Loader
    }
  }
</script>

<style lang="sass" scoped>
  .slider
    padding: 15px 8px 0
</style>



// WEBPACK FOOTER //
// Tiny.vue?358ff6ad